// extracted by mini-css-extract-plugin
export default {"zoomModal":"V0-z"};